<!-- 绘画列表页 -->
<template>
  <div class="component-header">
    <div class="banner" v-loading="loading">
      <div class="textcontent" v-if="leftNavIndex == 1">
        <wzlist :datalist="datalist" />
      </div>
      <el-empty v-if="datalist.length <= 0" :image-size="200" class="empty" />
    </div>
    <!-- 视频弹窗 开始 -->
    <video-dialog ref="VideoDialog" />
    <!-- 视频弹窗 结束 -->

    <div class="ptankuang" v-show="tankuang">
      <div class="ctankuang">
        <div class="tishititle" style="color:red;text-align:center;">
          温馨提示
        </div>
        <div id="qrcode"></div>
        <div class="btnssss">
          <div class="tishiwenzi">请使用微信扫码后操作</div>
          <el-button @click="closetankuang()">关 闭</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import VideoDialog from "../components/video-dialog.vue"; // 视频弹窗
import Wzlist from "../components/wzlist.vue"; // 文章列表页
import { getVideoposter } from "@/utils/getVideoposter";
import { indexlistData } from "@/api/datas";
import QRCode from "qrcodejs2"; // 引入qrcode
export default {
  name: "ComponentHeader",
  components: {
    VideoDialog,
    Wzlist
  },
  props: ["word"],
  data() {
    return {
      tankuang: false,
      isphone: false,
      loading: false,
      total: 0, // 数据总量
      size: 10, // 每页显示的数据数量
      current: 1, // 当前页数
      //文章列表数据
      wzlist: [
        // {
        //   id: 1,
        //   title: "“我身边的英烈”主题征集活动获奖作品揭晓",
        //   Intro:
        //     "2021年下半年，退役军人事务部在全社会广泛开展“我身边的英烈”主题征集活动。活动围绕庆祝中国共产党成立100周年主题，大力弘扬伟大建党精神，全面展现党在各个历史时期形成的革命精神、优良作风、红色传统，引导广大群众讲述英烈故事...",
        //   links:
        //     "http://www.chinamartyrs.gov.cn/x_xwzx/xwfb/202201/t20220124_55503.html"
        // },
        // {
        //   id: 1,
        //   title: "“我身边的英烈”主题征集活动一等奖作品展示",
        //   Intro:
        //     "每次回到故乡，总会把车停在村头。我的目光不由自主地向那个山岗遥望。那里，有十一座坟茔，那里，埋葬着十五六岁的司号员“小解放”。村委会办公室里，村书记小心翼翼地从柜子里轻轻捧出一个红布包裹，剥开一层层的红布，是一个锈迹斑斑的圆形铁壳子...",
        //   links:
        //     "http://www.chinamartyrs.gov.cn/x_xwzx/zhzx/202201/t20220124_55505.html"
        // }
      ],

      datalist: [],
      menudatatype: [
        // 服务器上的类型的信息
        {},
        { name: "文章类", ActivityId: 97969, Prefix: "r9ekyf" },
        { name: "绘画类", ActivityId: 97972, Prefix: "ads1fy" },
        { name: "摄影类", ActivityId: 97970, Prefix: "8bcvxl" },
        { name: "微视频类", ActivityId: 97971, Prefix: "6pbmul" }
      ]
    };
  },
  computed: {
    ...mapState([
      "userinfo", // 用户信息
      "headerNavIndex", // 当前激活的导航菜单的下标
      "leftNavIndex" //四个类型的作品类型下标
    ]),
    leftIndexc() {
      return this.$store.state.leftNavIndex;
    },
    searchwordc() {
      return this.$store.state.searchword;
    }
  },
  watch: {
    // 监听leftNavIndex值的改变
    leftIndexc(n, m) {
      console.log("leftIndexc：", n);
      this.current = 1;
      this.getList(n, "");
    },
    // 监听leftNavIndex值的改变
    searchwordc(n, m) {
      console.log("searchwordc", n);
      this.current = 1;
      this.getList(this.$store.state.leftNavIndex, n);
    }
  },
  mounted() {
    var arr = [
      { name: "活动介绍", to: "/" },
      { name: "公示投票", to: "/publicvoting" }
    ];
    console.log("arr：", JSON.stringify(arr));
    if (this.isMobile()) {
      this.isphone = true;
    } else {
      this.isphone = false;
    }
    console.log("word:", this.word);
    // 获取数据列表asd
    this.getList(this.$store.state.leftNavIndex, this.$store.state.searchword);
  },
  methods: {
    /**
     * ##########################################################################################
     * @description 点击了视频
     * @param {Object} item : 视频数据对象
     * ##########################################################################################
     */
    onClickVideo(item) {
      this.$refs["VideoDialog"].show(item.VideoUrl, item.poster);
    },
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    // 首页和尾页
    jumpFirstPage() {
      this.$refs.pagination.handleCurrentChange(1);
      this.$emit("handleCurrentChange", 1);
    },
    jumpLastPage() {
      let font = this.$refs.pagination;
      let cpage = Math.ceil(font.total / font.pageSize);
      font.handleCurrentChange(cpage);
    },
    /**
     * ##########################################################################################
     * @description 切换烈士列表页码
     * @param {Number} currentPage : 切换后的页码
     * ##########################################################################################
     */

    changeCurrentPage(currentPage) {
      this.current = currentPage;
      this.getList(
        this.$store.state.leftNavIndex,
        this.$store.state.searchword
      );
      console.log("最新页码：" + currentPage);
    },
    /**
     * ##########################################################################################
     * @description 获取烈士姓名列表
     * ##########################################################################################
     */

    getList(menutype, searchword) {
      // TODO: request login api
      // this.loading = true;
      var res = [];
      // 文章类	  97969	 r9ekyf
      // 绘画类	  97972	 ads1fy
      // 摄影类	  97970	 8bcvxl
      // 微视频类	97971	 6pbmul

      var datax = {
        PageIndex: 1,
        PageSize: 10000,
        ActivityId: this.menudatatype[menutype]["ActivityId"],
        Prefix: this.menudatatype[menutype]["Prefix"]
      };
      var data = {
        PageIndex: this.current,
        PageSize: this.size,
        ActivityId: this.menudatatype[menutype]["ActivityId"],
        Prefix: this.menudatatype[menutype]["Prefix"]
      };
      if (searchword != "") {
        console.log(menutype, searchword);
        datax.SearchKey = searchword;
        data.SearchKey = searchword;
      }
      indexlistData().then(resx => {
        this.datalist = resx;
        this.loading = false;
      });
    },
    /**
     * ##########################################################################################
     * @description 头像下拉菜单点击事件
     * @param {String} command : dropdown-item 的指令
     * ##########################################################################################
     */

    handleCommand(command) {
      console.log("点击了菜单:", command);
    },
    open(url) {
      if (this.isMobile()) {
        window.open(url);
      } else {
        this.stop();
        $("#qrcode").html("");
        this.qrcode(url);
        this.tankuang = true;
      }
    },
    closetankuang() {
      this.tankuang = false;
      this.move();
    },
    qrcode(url) {
      let qrcode = new QRCode("qrcode", {
        width: 180,
        height: 180,
        text: url // 二维码地址
      });
      console.log("qrcode：", qrcode);
    },
    //禁止滚动
    stop() {
      var mo = function(e) {
        e.preventDefault();
      };
      document.body.style.overflow = "hidden";
      document.addEventListener("touchmove", mo, false); //禁止页面滑动
    },
    /***取消滑动限制***/
    move() {
      var mo = function(e) {
        e.preventDefault();
      };
      document.body.style.overflow = ""; //出现滚动条
      document.removeEventListener("touchmove", mo, false);
    }
  }
};
</script>

<!-- 组件独有样式 -->
<style scoped>
/* 弹框 */
.ptankuang {
  position: fixed;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
.ctankuang {
  background-color: rgb(255, 255, 255);
  width: 500px;
  height: 430px;
  margin: 0 auto;
  position: absoulte;
  top: 50%;
  left: 50%;
  margin-top: 15%;
}
/* 提示大标题 */
.tishititle {
  position: relative;
  top: 30px;
  font-size: 20px;
}
/* 二维码提示文字 */
.tishiwenzi {
  font-size: 16px;
  margin-bottom: 5px;
}
/* 二维码图片 */
#qrcode {
  /* padding-left: 150px;
  padding-top: 50px; */
  width: 100%;
  height: 200px;
  position: relative;
  top: 50px;
  text-align: center;
}
/* 关闭二维码弹框 */
.btnssss {
  width: 100%;
  position: relative;
  /* top: 50px; */
  text-align: center;
  /* margin-top: 20px; */
  bottom: -100px;
}
/* 分页 */
.pagesment {
  margin: 0 auto;
}
.el-pagination {
  margin: 0 auto;
  margin-top: 20px;
  /* 手机端需要添加的样式 */
  /* padding-top: 20px; */
}
.bigimg {
  position: relative;
}
.video {
  width: 80px !important;
  height: 80px !important;
  position: absolute;
  left: 220px;
  top: 110px;
  display: inline;
  opacity: 0.8;

  /* background-color: rgba(22, 20, 20, 0.3);
  background-size: 100%; */
}
.video:hover {
  cursor: pointer;
  opacity: 1;
  transform: scale(1);
  transition: all 0.4s;
  /* background-color: rgba(22, 20, 20, 0.3);
  background-size: 100%; */
}
.tiaozhuan {
  margin-top: 23px;
}
.my-btn {
  float: left;
  padding: 10px 20px;
  margin-top: 22px;
}
/* 暂无数据是的样式 */
.empty {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: 120px 0;
  background-color: rgba(255, 255, 255, 0.5);
}
.component-header {
  position: relative;
  min-width: 1200px;
}
.titlehang1 {
  width: 100%;
  overflow: hidden; /*超出部分隐藏*/
  white-space: nowrap; /*不换行*/
  text-overflow: ellipsis; /*超出部分文字以...显示*/
}
.active {
  background-color: var(--main-color);
  color: #fff;
}
.banner {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
  padding-bottom: 100px;
}
.banner ul li {
  margin-top: 80px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  height: 380px;
  border-bottom: solid 1px #cfc1b9;
}
.banner .hhimg img {
  /* width: 100%; */
  /* height: 300px; */
  /* transition: all 0.6s; */
}
.widthimg {
  width: 100%;
}
.heightimg {
  height: 100%;
}
/* 
.banner .hhimg img:hover {
  transform: scale(1.2);
} */
.banner .hhimg .kuang {
  width: 520px;
  text-align: center;
  border: 1px solid #ddd;
  overflow: hidden;
  height: 300px;
  background: #ecf1f4;
  border-radius: 5px;
  overflow: hidden;
}
.banner .hhright {
  margin-left: 100px;
  width: 580px;
  height: 300px;
  position: relative;
}
/* 文章类型列表数据 */
.banner .wwcontent {
  width: 100%;
}
.banner .hhright .rtop {
  font-family: "思源宋体";
}
.banner .hhright .rtitle {
  height: 34px;
  line-height: 36px;
  font-size: 32px;
  margin-bottom: 43px;
}
.banner .hhright .rtitle a {
  color: #000;
}
.banner .hhright .rtauthor {
  height: 18px;
  line-height: 18px;
  font-size: 18px;
}

.banner .hhright .rbottom {
  width: 220px;
  height: 100px;
  position: absolute;
  bottom: 0;
  right: 0;
}
.banner .hhright .rbottom .rttoupiao {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 45px;
  color: #fff;
  border: none;
  border-radius: 5px;
  background-color: var(--main-color);
  font-size: 28px;
}
.banner .hhright .rbottom .rtnum {
  font-size: 22px;
}
.banner .hhright .rbottom .rtnum .rtnums {
  color: var(--main-color);
  font-size: 30px;
  height: 30px;
  line-height: 30px;
}
/* 列表页开始 */
.textcontent {
  height: auto;
  margin: 0 auto;
}
.content {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 10;
  display: flex;
  flex-direction: column;
  padding-bottom: 58px;
}

.top {
  flex-shrink: 0;
  height: 80px;
  border-bottom: 1px solid rgba(255, 238, 205, 0.2);
}

.top .main-content {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.top .logo {
  height: 52px;
}

.top .links {
  display: flex;
  align-items: center;
}

.top .link {
  font-size: 16px;
  color: #ffffff;
  width: 75px;
  height: 38px;
  line-height: 38px;
  text-align: center;
}

.top .link-register {
  background: linear-gradient(0deg, #f7ba5e 0%, #ffeeb4 100%);
  border-radius: 10px;
  color: var(--main-color);
  font-weight: bold;
}

.mid {
  flex: 1;
}

.mid .main-content {
  height: 100%;
  display: flex;
  align-items: center;
}

.mid .web-title {
  height: 73px;
}

.navs {
  width: 100%;
  height: 58px;
  position: absolute;
  left: 0;
  bottom: 0;
  background-color: rgba(109, 3, 4, 0.9);
  z-index: 20;
}

.navs .main-content {
  height: 100%;
  display: flex;
}

.navs .link {
  flex: 1;
  flex-shrink: 0;
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.8);
  transition: all 0.4s;
  border-right: 1px solid rgba(255, 255, 255, 0.15);
  font-size: 16px;
  position: relative;
}

.navs .link:first-child {
  border-left: 1px solid rgba(255, 255, 255, 0.15);
}

.navs .link::after {
  content: "";
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: -1;
  background: linear-gradient(0deg, #f7ba5e 0%, #ffeeb4 100%);
  left: 0;
  top: 0;
  opacity: 0;
  transform: scale(0);
  transition: all 0.4s;
}

.navs .link:hover {
  color: var(--main-color);
  font-weight: bold;
  font-size: 18px;
}

.navs .link:hover::after {
  opacity: 1;
  transform: scale(1);
}

.navs .link.active {
  color: var(--main-color);
  font-weight: bold;
  font-size: 18px;
}

.navs .link.active::after {
  opacity: 1;
  transform: scale(1);
}

.has-login-wrapper {
  display: flex;
  align-items: center;
  font-size: 16px;
}

.has-login-wrapper .link-mine {
  color: #f7f17d;
  font-weight: bold;
  margin-right: 16px;
}

.has-login-wrapper .userinfo {
  display: flex;
  align-items: center;
}

.has-login-wrapper .avatar {
  width: 48px;
  height: 48px;
  border: 2px solid #fbd48b;
  margin-right: 8px;
  cursor: pointer;
}

.has-login-wrapper .nickname {
  color: #ffffff;
}
.has-login-wrapper .logouts {
  color: #bb1515;
  border: solid 1px #ef7878;
  padding: 3px;
  background-color: #eae3b6;
  border-radius: 5px;
  cursor: pointer;
  margin-left: 10px;
}
.has-login-wrapper .logouts:hover {
  color: #e72c2c;
}
.has-login-wrapper .logouts:active {
  color: #9b2020;
}
</style>



// WEBPACK FOOTER //
// src/components/indexhhlist.vue